<template>
  <div class="phonepage flexCloumnSingleCenter">
    <div class="form">
      <div class="cell-group-title flexStart"></div>
      <div class="cell-group">
        <van-field :readonly="disabled" v-model="editForm.department" label="系部" required
                   placeholder="请输入系部">
        </van-field>
        <van-field :readonly="disabled" v-model="editForm.class" label="班级" required
                   placeholder="请输入班级">
        </van-field>
      </div>

      <div class="cell-group-title flexStart"></div>
      <div class="cell-group">
        <van-field :readonly="disabled" v-model="editForm.stuName" label="姓名" required placeholder="请输入姓名"/>
        <van-field :readonly="disabled" class="childBox" name="checkbox" label="是否团员" required>
          <template #input>
            <van-radio-group :disabled="disabled" :readonly="disabled"
                             v-model="editForm.istuanyuan"
                             direction="horizontal">
              <van-radio name="1">是</van-radio>
              <van-radio name="0">否</van-radio>
            </van-radio-group>
          </template>
        </van-field>

        <van-field :readonly="disabled" class="childBox" name="checkbox" label="是否住校" required>
          <template #input>
            <van-radio-group :disabled="disabled" :readonly="disabled"
                             v-model="editForm.isdorm"
                             direction="horizontal">
              <van-radio name="1">是</van-radio>
              <van-radio name="0">否</van-radio>
            </van-radio-group>
          </template>
        </van-field>

        <van-field :readonly="disabled" v-model="editForm.phoneType" label="手机型号" required placeholder="品牌+型号"/>
        <van-field :readonly="disabled" v-model="editForm.phone" label="手机号码" required placeholder="请输入手机号"/>

      </div>

      <div class="cell-group" style="margin-top: 10px;">
        <div class="flexCloumn" style="width: 100%;">
          <div class="item-title flexStart">手机带入学校申请原因陈述</div>
          <div class="item-input" style="border-bottom: 0.5px solid #ebedf0;">
            <el-input :disabled="disabled" v-model.trim="editForm.remark" type="textarea" placeholder="请输入内容……"
                      :autosize="{ minRows: 4, maxRows: 10 }" style="width: 100%"/>
          </div>
        </div>

        <div class="flexCloumn" style="width: 100%;">
          <div class="item-title flexStart">
            <span style="color: #1283FF">*</span>
            <span class="flexCenter">监护人签名</span>
            <el-tag v-if="!disabled" size="small" @click="goSign" class="signBtn">
              {{ !editForm.signUrl ? '前往签名' : '修改签名' }}
            </el-tag>
          </div>
          <div class="signUrl-box">
            <img :src="editForm.signUrl" mode="aspectFit"></img>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!disabled" class="submitBtn flexCenter" style="background-color:#fff;">
      <div class="btn btnChange" @click="onSubmitForm">确定</div>
    </div>
    <div v-if="disabled" class="submitBtn flexCenter" style="background-color:#fff;">
      <div class="btn" @click="onModify">点击修改</div>
    </div>
    <div style="width: 100%;height: 100px;background-color:#fff;"></div>


    <!--    签名-->
    <div v-if="showhandsign" style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0,0,0,0.6);">
      <handSign  @returnImg="getHandSign"></handSign>
    </div>

  </div>
</template>

<script>
import {
  Toast, Dialog
} from 'vant';
import wx from 'weixin-js-sdk'
import handSign from "../../../com/handSign.vue"

export default {
  components: {
    handSign
  },
  // props: {
  //   tableInfo: {
  //     type:Object,
  //     default:{}
  //   },
  //   signUrl: {
  //     type:String,
  //     default:''
  //   },
  //   stu_id:{
  //     type:Number,
  //     default:0
  //   },
  //   pmid: {
  //     type:Number,
  //     default:5
  //   },
  // },
  data() {
    return {
      editForm: {
        department: '',
        class: '',
        stuName: '',
        istuanyuan:'',
        isdorm:'',
        phoneType:'',
        phone: '',//13333333333
        remark: '',
        signUrl: '',
      },
      openid: null,
      disabled: false,
      pmid:5,
      stu_id:0,
      signUrl: '',
      tableInfo:{},
      showhandsign:false,
    }
  },
  mounted() {
    // console.log('wx',wx)
    let _this = this
    $(".phonepage").height($(window).height())//设置页面高度固定，防止输入法弹出页面变形，注意内部元素不能使用vh

    if (this.$route.query) {
      console.log(79, this.$route.query)
      this.stu_id = Number(this.$route.query.stu_id)
      this.pmid = Number(this.$route.query.pmid)
      if(this.$route.query.signurl){
        this.asyncLocalStorage.getItem('editForm').then(r => {
          let editForm = localStorage.getItem('editForm')
          if (editForm) {
            editForm = JSON.parse(editForm)
            //转Boolean
            if(editForm.isConfirmStu=='true'){editForm.isConfirmStu=true}
            if(editForm.isConfirmParent=='true'){editForm.isConfirmParent=true}
            if(editForm.isConfirmStu=='false'){editForm.isConfirmStu=false}
            if(editForm.isConfirmParent=='false'){editForm.isConfirmParent=false}
            _this.editForm = {...editForm}
            console.log(1,this.$route.query.signurl)
            _this.editForm.signUrl = decodeURIComponent(_this.$route.query.signurl)
            this.editForm = {..._this.editForm}
            console.log(162,_this.editForm)
          }
        })
      }else {
        _this.getList(1)
      }

    }
  },
  methods: {
    getStuInfo(){
      let _this = this
      return new Promise(resolve => {
        this.$http.post("/api/stu_luqu_detail", {
          stu_id: _this.stu_id,
          pmid: this.pmid
        }).then(res => {
          console.log(res.data)
          if(res.data){
            _this.editForm.department = res.data.yuanxi_name
            _this.editForm.major_name = res.data.major_name
            _this.editForm.class = res.data.class_name
            _this.editForm.stuName = res.data.stu_name
            _this.editForm.gender = String(res.data.gender)
            _this.editForm.phone =res.data.phone
            _this.editForm.isdorm =String(res.data.dorm)
            if (res.data.zzmm && res.data.zzmm == '团员') {
              _this.editForm.istuanyuan = '1'
            } else {
              _this.editForm.istuanyuan = ''
            }
            _this.editForm = {..._this.editForm}
            console.log(_this.editForm)
          }
          resolve()
        })
      })
    },

    getList(flag) {
      let _this = this
      return new Promise(resolve => {
        this.$http.post('/api/t_stu_check_in_table_list', {
          pmid: _this.pmid,
          stu_id: _this.stu_id
        }).then(res => {
          for (let item of res.data.data) {
            if (item.table_name.indexOf('携带手机') != -1) {
              document.title = item.table_name
              _this.tableInfo = item

              if(flag == 1){
                if (item.table_detail) {
                  let detail = JSON.parse(item.table_detail)
                  _this.editForm = Object.assign(detail)
                  _this.disabled = true
                } else {
                  _this.getStuInfo()
                  _this.disabled = false
                }
              }
              console.log(_this.editForm)
              resolve()
              return;
            }
          }
          resolve()
        })
      })

    },

    checkPhone(v) {
      let strTemp = /^1[3|4|5|6|7|8|9][0-9]{9}$/;
      if (strTemp.test(v)) {
        return true;
      }
      return false;
    },
    onSubmitForm() {
      let _this = this
      console.log(this.editForm)
      if (!this.editForm.department) {
        Toast('请填写系部！');
        return
      }
      if (!this.editForm.class) {
        Toast('请填写班级！');
        return
      }
      if (!this.editForm.stuName) {
        Toast('请填写学生姓名！');
        return
      }
      if (!this.editForm.istuanyuan) {
        Toast('请选择是否团员！');
        return
      }
      if (!this.editForm.isdorm) {
        Toast('请选择是否住宿！');
        return
      }
      if (!this.editForm.phoneType) {
        Toast('请填写手机品牌型号！');
        return
      }
      if (!this.editForm.phone) {
        Toast('请填写手机号码！');
        return
      }
      if (this.editForm.phone && !_this.checkPhone(this.editForm.phone)) {
        Toast('输入手机号格式不正确！');
        return
      }
      if (!this.editForm.remark) {
        Toast('请填写申请原因！');
        return
      }
      if (!this.editForm.signUrl) {
        Toast('家长签名不能为空！');
        return
      }
      _this.getList(0).then(result=>{
        console.log(_this.tableInfo)
        let params = {}
        params.table_detail = JSON.stringify(_this.editForm)
        params.table_name = _this.tableInfo.table_name
        params.table_code = _this.tableInfo.table_code
        params.stu_id = this.stu_id
        params.table_type_id = _this.tableInfo.type_id
        params.pmid = this.pmid
        if(_this.tableInfo.id){
          params.id = _this.tableInfo.id
        }
        console.log(params)
        this.requestForm(params)
      })
    },
    requestForm(params) {
      let _this = this
      this.$http.post("/api/t_stu_check_in_table_edit", params).then(function (res) {
        if (res.data.id||res.data.message=='') {
          Toast('保存成功！')
          localStorage.removeItem('tableInfo')
          localStorage.removeItem('editForm')
          setTimeout(function (){
            _this.editForm = {}
            wx.miniProgram.navigateBack({
              delta: 1
            })
          },500)
          _this.preExport()
        } else {
          Toast(res.data.msg)
          _this.disabled = false
        }
      })

    },

    preExport() {
      let _this = this
      this.$http.post("/api/stu_luqu_detail", {
        stu_id: _this.stu_id,
        pmid: _this.pmid
      }).then(res => {
        console.log(res.data)
        if (res.data.class_id) {
          let params = {
            class_id: _this.editForm.class_id,
            stu_ids: _this.stu_id,
            pmid: _this.pmid,
          }
          _this.$http.post("/api/exportWord1", params).then(function (res) {})
        }

      })


    },

    goSign() {
      this.showhandsign = true
      return

      this.asyncLocalStorage.setItem('editForm', JSON.stringify(this.editForm)).then(r => {
        console.log('localStorage editForm', localStorage.getItem('editForm'))
        wx.miniProgram.navigateTo({
          url: '/pages/handsign/handsign?from=h5phone'
        })
      })
    },
    getHandSign(e){
      console.log(e)

      this.showhandsign = false
      if(e){
        this.$http.post("/api/save_base64_img",{base64_img:e}).then(res=>{
          this.editForm.signUrl = res.data.url
        })
      }

    },

    onModify() {
      let curTime = new Date().getTime()
      let time1 = new Date(this.tableInfo.cdate).getTime()
      let val = curTime - time1
      this.getDuration(val).then(result => {
            console.log(result.d,result.h)
            if (result.d > 0 || result.h > 3) {
              this.disabled = false
            } else {
              Dialog.alert({
                title: "距上次提交时间小于3小时，请不要频繁修改。",
                showCancelButton: false,
                confirmButtonText: "确定",
                cancelButtonText: "关闭",
                confirmButtonColor: '#1283FF',
              }).then(() => {
                this.disabled = true
              }).catch(() => {
                console.log("点击了取消按钮噢")
              })
            }
          }
      )
      console.log(new Date(), this.tableInfo.cdate, this.tableInfo)
    },
    getDuration(my_time) {
      return new Promise(resolve => {
        var days    = my_time / 1000 / 60 / 60 / 24;
        var daysRound = Math.floor(days);
        var hours = my_time / 1000 / 60 / 60 - (24 * daysRound);
        var hoursRound = Math.floor(hours);
        var minutes = my_time / 1000 / 60 - (24 * 60 * daysRound) - (60 * hoursRound);
        var minutesRound = Math.floor(minutes);
        var seconds = my_time / 1000 - (24 * 60 * 60 * daysRound) - (60 * 60 * hoursRound) - (60 * minutesRound);
        console.log('转换时间:', daysRound + '天', hoursRound + '时', minutesRound + '分', seconds + '秒');
        var time = hoursRound + ':' + minutesRound + ':' + seconds
        let obj = {d:daysRound,h:hoursRound}
        resolve(obj)
        return time;
      })

    },
  },
}
</script>

<style lang="less" type="text/less">
.el-textarea__inner:focus {
  outline: 0;
  border-color: #1283FF !important;
}

.van-radio__icon {
  font-size: 16px;
}

.van-radio__icon--checked .van-icon {
  background-color: #1283FF;
  border-color: #1283FF;
}

.van-checkbox {
  margin-top: 10px;
}

.van-checkbox__icon {
  font-size: 16px;
}

.van-checkbox__icon--checked .van-icon {
  background-color: #1283FF;
  border-color: #1283FF;
}

.van-tag--primary {
  background-color: #1283FF;
}

.van-cell--required::before {
  color: #1283FF !important;
}

.phonepage {
  display: block;
  box-sizing: border-box;
  width: 100vw;
  height: 100vh;
  overflow-y: scroll;
  background-color: #f5f5f5;

  .form {
    flex: 1;
    width: 100%;
    box-sizing: border-box;

    div {
      font-size: 14px;
      color: #323232;
      box-sizing: border-box;
    }

    .cell-group-title {
      margin: 10px 0 5px 15px;
      font-size: 14px;
      color: #969799;
    }

    .cell-group {
      padding: 0 20px;
      background-color: #fff;
    }

    .topInfo {
      color: #00D1CB;
      font-size: 12px;
    }

    .item-title {
      position: relative;
      box-sizing: border-box;
      width: 100%;
      padding: 10px 16px;
    }

    .item-input {
      position: relative;
      box-sizing: border-box;
      width: 100%;
      padding: 0 16px 10px 16px;
      font-size: 14px;
      color: #646566;
    }

    .item-input1 {
      color: #ee0a24;
      font-size: 12px;
      line-height: 18px;
    }

    .item-input1::after {
      position: absolute;
      box-sizing: border-box;
      content: ' ';
      pointer-events: none;
      right: 16px;
      bottom: 0;
      left: 16px;
      border-bottom: 1px solid #ebedf0;
      -webkit-transform: scaleY(.5);
      transform: scaleY(.5);
    }

    .signUrl-box {
      margin-top: 10px;
      border: 1px solid #EEF2F5;
      width: 100%;
      height: 150px;
      padding: 10px;
    }

    .signUrl-box img {
      display: inline-block;
      max-width: 100%;
      max-height: 100%;
    }

    .signBtn {
      margin-left: 10px !important;
      margin-top: 1px;
    }
  }

  .submitBtn {
    padding-top: 6vh;
    width: 100%;

    .btn {
      display: inline-block;
      padding: 1.4vh 0;
      width: 60%;
      text-align: center;
      background-color: #1283FF;
      color: #fff;
      font-size: 15px;
      border-radius: 6px;
    }
  }
}

</style>
